// extracted by mini-css-extract-plugin
module.exports = {"loader":"e","smallLoader":"f","loading-keyframes":"g","pageLoader":"h","centered":"i","whitespacePlaceholder":"j","buttonSpinner":"k","fade-in":"l","rotate":"m"};